module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.f7ee2cda.webp";